/* eslint-disable */
import { int, months, pad, slugify, VueDate, weekdays } from './'

export function date(inputDate) {
  const vdate = VueDate(inputDate)
  const sameYear = vdate.year === new Date().getUTCFullYear()

  return `${months[vdate.month]} ${vdate.date}${sameYear ? '' : ', ' + vdate.year}`
}

export function name(user) {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim()
}

export function initials({ firstName, lastName }) {
  return [firstName, lastName]
    .filter(x => x)
    .map(name => name[0])
    .join('')
    .toUpperCase()
}

export function firstInitial(user) {
  return (user.firstName || user.email).toUpperCase()[0]
}

export function datetime(inputDate) {
  return `${date(inputDate)}, ${time(inputDate)}`
}

export function year(inputDate) {
  const vdate = VueDate(inputDate)
  return vdate.year
}

export function month(inputDate) {
  const vdate = VueDate(inputDate)
  return months[vdate.month]
}

export function day(inputDate) {
  const vdate = VueDate(inputDate)
  return vdate.date
}

export function ago(inputDate) {
  const diff = (Date.now() - new Date(inputDate).valueOf()) / 1000
  return diff >= 0 ?
          timeDiff(diff) + ' ago' :
          'in ' + timeDiff(diff * -1)
}

// export const minutes = min => timeDiff(min * 60)
export function time(inputDate) {
  let hour, minute
  if (typeof inputDate === 'number') {
    hour = Math.floor(inputDate / 60)
    minute = inputDate % 60
  } else {
    inputDate = VueDate(inputDate)
    hour = inputDate.hours
    minute = inputDate.minutes
  }

  return `${pad(hour)}:${pad(minute)}`
}

export function weekday(datetime) {
  const day = VueDate(datetime)
  return weekdays[day.obj.getDay()]
}

function timeDiff(diff) {
  if (diff < 3600) {
    return pluralize(~~(diff / 60), 'minute')
  } else if (diff < 86400) {
    return pluralize(~~(diff / 3600), 'hour')
  } else {
    return pluralize(~~(diff / 86400), 'day')
  }
}

export function first(str) {
  return str[0]
}

export function pluralize(amount, label) {
  if (amount === 1) {
    return amount + ' ' + label
  }

  return amount + ' ' + label + 's'
}

// append http:// if necessary
// export const link = url =>
//   url.indexOf('http://') === -1 ? 'http://' + url : url

// 10000 => 10,000
export const money = (number, places = 2) => {
  const decimalSplit = number.toFixed(places).split('.')
  const isNegative = number < 0
  const out = decimalSplit[0]
    .replace('-', '')
    .split('')
    .reverse()
    .map((char, index, arr) =>
      ((index + 1) % 3 === 0 && arr.length !== index + 1) ? ',' + char : char)
    .reverse()
    .join('')

  const decimal = decimalSplit[1] ? `${out}.${decimalSplit[1]}` : out

  return isNegative ? '-' + decimal : decimal
}

// 10000 => 10K
export const metricNumber = number =>
  ['K', 'M', 'B'].reduce((acc, letter) =>
    int(acc) > 1000 ? Math.round(int(acc) / 1000) + letter : acc, number)

// 10000 => €10,000
export const currency = (number, symbol = '€', places) =>
  money(number, places).replace(/(-?)(.*)/, `$1${symbol}$2`)

// export const decimal = (number, points = 1) =>
//   number == 0 || number == null ?
//   0 : number.toFixed(points)

// class for alternating classes
export const alt = index => index % 2 ? 'alt' : ''

// export const uppercase = str => str.toUpperCase()

export const vehicleName = vehicle =>
  `${vehicle.brand || ''} ${vehicle.model || ''}`

export { slugify as slug }
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/utils/filters.js